'use client';

import { AuthAffordance, AuthAffordanceVariant } from '@vs-shop/commerce-ui/authAffordance';
import { useAppSearchParams } from '../../../shared/router/AppRouterContext';
import { useIntl } from 'react-intl';

import { Url } from '../../../route/router';

import Link from '@vs-shop/image-link/Link';

export default function OpenRegistration() {
  const intl = useIntl();
  const searchParams = useAppSearchParams();
  const encodedParams = searchParams.toString();
  const switchToRegisterUrl = `${Url.registration}${encodedParams ? `?${encodedParams}` : ''}`;

  return (
    <AuthAffordance
      variant={AuthAffordanceVariant.PLAIN}
      data-slot="login-open-registration"
      render={<Link href={switchToRegisterUrl} />}
    >
      {intl.formatMessage({
        id: 'component.loginWrapper.switchToRegister',
        defaultMessage: 'Ještě nemám vytvořen účet a chci se zaregistrovat',
      })}
    </AuthAffordance>
  );
}
